// extracted by mini-css-extract-plugin
module.exports = {"container":"InfoBadge_container__3S52_","imageContainer":"InfoBadge_imageContainer__1gOvd","text":"InfoBadge_text__1ZiPm"};